

export default class BrasilApiService {
    getCnpjInfo(cnpj) {
        const axios = require('axios');
        return axios.get('https://brasilapi.com.br/api/cnpj/v1/' + cnpj)
    }
}